module.exports = __webpack_public_path__ + "img/hex_backdrop_light_gray.459ff834.png";